import { api, apiWithRetry, PaginatedResult, parsePaginatedResult, unwrapApiResult } from './api'
import {
  CustomerInterface,
  CustomerResponseInterface,
  parseCustomerModel,
} from '../models/CustomerModel'
import {
  parseProductModel,
  ProductInterface,
  ProductResponseInterface,
} from '../models/ProductModel'
import { parseSale, SaleInterface } from '../models/SaleModel'

export async function getCustomers(
  page = 1,
  search = ''
): Promise<PaginatedResult<CustomerInterface>> {
  const result = await api<CustomerResponseInterface[]>({
    method: 'GET',
    url: '/customers',
    params: {
      page,
      search,
    },
  })

  const data = unwrapApiResult(result)

  return parsePaginatedResult(data, parseCustomerModel)
}

export async function getProducts(
  page = 1,
  search = ''
): Promise<PaginatedResult<ProductInterface>> {
  const result = await api<ProductResponseInterface[]>({
    method: 'GET',
    url: '/products',
    params: {
      page,
      search,
    },
  })

  const data = unwrapApiResult(result)

  return parsePaginatedResult(data, parseProductModel)
}

export async function completeSale(
  saleData: SaleInterface,
  existingSaleId: string | null
): Promise<void> {
  const result = await apiWithRetry(
    {
      method: existingSaleId ? 'PUT' : 'POST',
      url: `manual-orders${existingSaleId ? `/${existingSaleId}` : ''}`,
      params: {
        ...saleData,
      },
    },
    { retries: 2, baseDelayMs: 400, maxDelayMs: 2500 }
  )

  unwrapApiResult(result)
}

export async function getSale(orderId: string): Promise<SaleInterface> {
  const result = await apiWithRetry(
    {
      method: 'GET',
      url: `/manual-orders/${orderId}`,
    },
    { retries: 2, baseDelayMs: 400, maxDelayMs: 2500 }
  )

  const data = unwrapApiResult(result)

  return parseSale(data.data, orderId)
}
